import React from 'react';
import { Menu as AntMenu } from 'antd';

/**
 * Wrapper component for Ant Design Menu
 *
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Menu functionality and sub-components.
 *
 * @component
 * @example
 * import { Menu } from '../GeneralComponents/ui';
 *
 * <Menu>
 *   <Menu.Item key="1">Option 1</Menu.Item>
 *   <Menu.Item key="2">Option 2</Menu.Item>
 *   <Menu.SubMenu key="sub1" title="Submenu">
 *     <Menu.Item key="3">Option 3</Menu.Item>
 *   </Menu.SubMenu>
 * </Menu>
 *
 * @see https://ant.design/components/menu/ - Ant Design Menu documentation
 */
const Menu = (props) => {
  return <AntMenu {...props} style={{ borderRadius: 16, ...props.style }} />;
};

// Preserve Menu sub-components
Menu.Item = AntMenu.Item;
Menu.SubMenu = AntMenu.SubMenu;
Menu.ItemGroup = AntMenu.ItemGroup;
Menu.Divider = AntMenu.Divider;

export default Menu;
